import * as Yup from 'yup';

export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required('Campo obrigatório'),
  newPassword: Yup.string().required('Campo obrigatório'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Senhas não conferem')
    .required('Campo obrigatório'),
});
